import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button,
         ButtonToolbar,
         Col,
         Grid,
         Row } from 'react-bootstrap';

import { Document, Page } from 'react-pdf';
import store from 'store';

import Config from './Config';
import { parseDate } from '../utils/Utils';

const logo = require('../assets/img/logo.png');
const iconUser = require('../assets/img/icon_user.png');


class ResultSummary extends Component {

    constructor(props, context) {
      super(props, context);
      this.state = {
        firstName: '',
        lastName: '',
      };
    }

    componentDidMount() {
      const token = store.get(Config.TOKEN);

      const resultId = store.get(Config.RESULT_ID);
      console.log('resultId', resultId);

      // Get member name
      const hospitalFilterUrl = `${Config.SERVER_URL}${Config.API_MEMBER_PROFILE}?token=${token}`;
      fetch(hospitalFilterUrl, {
            method: 'POST'
      })
      .then((response) => response.json())
      .then((responseJson) => {
          console.log('member profile', responseJson);
          this.setState({ firstName: responseJson.fname, lastName: responseJson.lname });
      })
      .catch((error) => {
          console.error(error);
      });
    }

    handleLogout(event){
      console.log('logging out ...');
      store.remove(Config.TOKEN);
      this.props.history.push({
        pathname: '/'
      });
    }

    handleBackClick() {
      this.props.history.push('/resultlist');
    }

    showPDF() {
      this.props.history.push({
        pathname: '/pdfReport'
      });
    }

    renderResultStatusTimeline(labResult) {
        return labResult.TestProcessList.map(resultRow =>
            <Row className="result-row" key={resultRow.LabTestProcessID}>
              <Col xs={1}>
                <svg height="30" width="30">
                  <circle cx="15" cy="15" r="13" stroke="white" strokeWidth="3" fill={resultRow.completed ? "green" : "red"} />
                </svg>
              </Col>
              <Col xs={11}>
                <Row className="text-timeline-status">{resultRow.keyDescription}</Row>
                <Row className="text-timeline-status-th">{resultRow.keyDescription2}</Row>
                <Row className="text-timeline-status-date">{(resultRow.completed && resultRow.actualDate) ? parseDate(resultRow.actualDate) : null}</Row>
              </Col>
            </Row>
        );
    }

    renderStatusLight(paymentStatusCode) {
        if (paymentStatusCode === '1UNPAID') {
            return (
                <span className="payment-status-badge pull-right">
                  <svg height="12" width="12">
                    <circle cx="6" cy="6" r="6" fill="red" />
                  </svg>
                  <span className="payment-status-name">Unpaid</span>
                </span>
            );
        } else if (paymentStatusCode === '2PENDING') {
            return (
                <span className="payment-status-badge pull-right">
                  <svg height="12" width="12">
                    <circle cx="6" cy="6" r="6" fill="orange" />
                  </svg>
                  <span className="payment-status-name">Pending</span>
                </span>
            );
        } else if (paymentStatusCode === '3PAID') {
            return (
                <span className="payment-status-badge pull-right">
                  <svg height="12" width="12">
                    <circle cx="6" cy="6" r="6" fill="green" />
                  </svg>
                  <span className="payment-status-name">Paid</span>
                </span>
            );
        }
    }

    renderResults(labResult) {
        return labResult.TestResultList.map(result =>
          <Col key={result.LabTestResultID}>
            <Row>
              <span className='text-white-panel-table-key'>{result.keyDescription ? result.keyDescription : null}</span>
              <span className='text-white-panel-table-value pull-right' style={{color: result.displayColor}}>{result.ResultDescription1 ? result.ResultDescription1 : null}</span>
            </Row>

            <Row>
              <span className='text-white-panel-table-key-th'>{result.keyDescription2 ? result.keyDescription2 : null}</span>
              <span className='text-white-panel-table-value-th pull-right' style={{color: result.displayColor}}>{result.ResultDescription2 ? result.ResultDescription2 : null}</span>
            </Row>
            <hr className='row horizontal-line-gray'/>
          </Col>

        );
    }

    render() {
        if(!store.get(Config.TOKEN)) {
          return <Redirect to='/' />;
        }
        const labResult = this.props.location.state.labResult;

        const pdfUrl = Config.SERVER_URL + Config.API_LAB_RESULT_FILE + '?token=' + store.get(Config.TOKEN) + '&TestCaseID=' + store.get(Config.RESULT_ID);

        console.log('ResultSummary labResult', labResult);
        return (
            <Grid fluid>
              <Row className="genode-header">
                <Col xs={2}>
                  <img src={logo} className="App-logo" alt="logo" />
                </Col>
                <Col xs={2} xsOffset={8}>
                  <Row>
                    <img src={iconUser} className="icon-user" alt="User icon" /><span className="App-title">{`${this.state.firstName} ${this.state.lastName}`}</span>
                  </Row>
                  <Row>
                    <span className="text-logout" onClick={(event) => this.handleLogout(event)}>Logout</span>
                  </Row>
                </Col>
              </Row>

              <br/>

              <Row>
                <Col className="gradient-panel" xs={10} xsOffset={1} >
                  <Row>
                    <span className='text-doctor-name pull-left'>{labResult.PatientName ? labResult.PatientName : null}</span>
                    {this.renderStatusLight(labResult.PaymentStatusCode)}
                  </Row>

                  <hr className='row horizontal-line-white'/>

                  <Row>
                    <span className='text-result-description-key'>Case No :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.CaseNo ? labResult.CaseNo : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>HN :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.HN ? labResult.HN : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>Sample Collection Date :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.getSampleDate ? parseDate(labResult.getSampleDate) : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>Hospital :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.HospitalName ? labResult.HospitalName : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>Doctor :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.DoctorName ? labResult.DoctorName : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>Payment Date :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.paymentDate ? parseDate(labResult.paymentDate) : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>Payment Channel :&nbsp;</span>
                    <span className='text-result-description-value'>{labResult.PaymentTypeName ? labResult.PaymentTypeName : null}</span>
                  </Row>

                  <Row>
                    <span className='text-result-description-key'>Remark :&nbsp;</span>
                    <span className='text-result-description-value'></span>
                  </Row>

                  <br/>

                  <Row>
                    <Col xs={4} className="transparent-panel">

                      <Row className="text-timeline-header">
                        สถานะการตรวจ
                      </Row>
                      {this.renderResultStatusTimeline(labResult)}

                    </Col>
                    <Col xs={8} className="white-panel">
                      <Row align="center" className="text-white-panel-title">
                        {labResult.resultTitle}
                      </Row>

                      <Row align="center" className="text-white-panel-title-gray">
                        {labResult.remark}
                      </Row>
                      <Row align="center" className="text-white-panel-title-gray-th">
                        {labResult.remark2}
                      </Row>

                      <hr className='row horizontal-line-gray-2px'/>

                      <Row>
                        <span className='text-white-panel-table-header'>Chromosome</span>
                        <span className='text-white-panel-table-header pull-right'>Risk Index</span>
                      </Row>

                      <Row>
                        <span className='text-white-panel-table-header-th'>โครโมโซม</span>
                        <span className='text-white-panel-table-header-th pull-right'>ความเสี่ยงที่เกิดขึ้น</span>
                      </Row>

                      <hr className='row horizontal-line-blue-5px'/>

                      {this.renderResults(labResult)}

                    </Col>
                  </Row>

                </Col>
              </Row>

              <br/>

              <div align='center'>
                <Button bsStyle="info" onClick={(event) => this.handleBackClick()}>กลับเมนูหลัก</Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;


                <Button onClick={() => window.open(pdfUrl, "_blank")} bsStyle="primary">Official Report</Button>


              </div>

              <br/>
              <br/>




            </Grid>
        );
    }
}

export default ResultSummary;



// WEBPACK FOOTER //
// ./src/components/ResultSummary.js